import api from '@/services/api'
import type { FavSymbolResponse } from './types'
import type { MarketType } from '@/utils/types'

export const FavSymbolsV2Service = {
  fetchFavSymbols() {
    return api.get<FavSymbolResponse[]>('/v2/fav-symbols')
  },
  putFavSymbol(ex_buy: string, ex_sell: string, marketType: MarketType, asset: string) {
    return api.put('/v2/fav-symbols', {
      ex_buy: ex_buy,
      ex_sell: ex_sell,
      asset: asset,
      market_type: marketType,
    })
  },
  deleteFavSymbol(rowId: number) {
    return api.delete(`/v2/fav-symbols/${rowId}`)
  },
}
